import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitArchiveOutboundCalls,
  submitCancelOutboundCall,
  submitCancelOutboundCalls,
  submitCreateOutboundCall,
  submitDialOutboundCall,
  submitMarkCallsAsSeen,
  submitUpdateOutboundCall
} from '~/api/data/calls/mutations';
import { loadOutboundCall } from '~/api/data/calls/queries';
import { loadOutboundVoiceAgents } from '~/api/data/voice/queries';
import { OutboundCallDetailPage } from '~/pages/calls/outbound-call-detail';
import {
  OutboundCallCreatePage,
  OutboundCallEditPage,
  OutboundCallsPage
} from '~/pages/calls/outbound-calls';

export const outboundCallsRoute: RouteObject = {
  path: 'outbound',
  loader: merge({
    outboundVoiceAgents: loadOutboundVoiceAgents
  }),
  element: <OutboundCallsPage />,
  children: [
    {
      path: 'archive',
      action: byMethod({ POST: submitArchiveOutboundCalls })
    },
    {
      path: 'cancel',
      action: byMethod({ POST: submitCancelOutboundCalls })
    },
    {
      path: 'mark-seen',
      action: byMethod({
        POST: submitMarkCallsAsSeen
      })
    },
    {
      path: 'new',
      action: submitCreateOutboundCall,
      element: <OutboundCallCreatePage />
    },
    {
      path: ':id',
      loader: merge({ outboundCall: loadOutboundCall }),
      element: <OutboundCallDetailPage />,
      children: [
        {
          path: 'edit',
          loader: merge({
            outboundCall: loadOutboundCall
          }),
          action: submitUpdateOutboundCall,
          element: <OutboundCallEditPage />
        },
        {
          path: 'dial',
          action: submitDialOutboundCall
        },
        {
          path: 'cancel',
          action: submitCancelOutboundCall
        }
      ]
    }
  ]
};
